<footer class="footer">
  <div class="footer__content">
    <div class="footer__content__grid">
      <!-- About -->
      <div class="footer__content__grid__about">
        <div>
          <img class="footer__image" src="assets/icons/proquifa-logo-nav.svg" alt="logo" width="216" height="47" />
          <p class="footer__content__grid__about__description text-body text-neutral-200">
            Somos el distribuidor líder de Material de Referencia químico y
            biológico para el mercado mexicano.
          </p>
        </div>
        <div class="footer__content__grid__about__social">
          <a href="https://www.linkedin.com/company/3861171" target="_blank">
            <img alt="Linkedin" src="assets/icons/social-linkedin.svg" />
          </a>
          <a href="https://www.facebook.com/proquifaoficial" target="_blank">
            <img alt="Facebook" src="assets/icons/social-facebook.svg" />
          </a>
          <a href="https://www.instagram.com/proquifa/" target="_blank">
            <img alt="Instagram" src="assets/icons/social-instagram.svg" />
          </a>
          <a href="https://x.com/PROQUIFA" target="_blank">
            <img alt="Twitter" src="assets/icons/social-twitter.svg" />
          </a>
        </div>
      </div>

      <div class="footer__content__grid__navigation">

        <!-- Categories -->
        <div class="footer__content__grid__navigation__categories">
          <span class="text-body-medium text-neutral-50">Catálogo</span>
          <div class="categories-list">
              <a
                class="text-body text-neutral-200 no-decoration"
                *ngFor="let item of categories$ | async"
                [routerLink]="['/products']"
                [queryParams]="{category: item.key}"
              >
                {{ item.label }}
              </a>
          </div>
        </div>


        <!-- Legal -->
        <div class="footer__content__grid__navigation__legal">
          <span class="text-body-medium text-neutral-50">Legal</span>
          <div class="legal-list">
            <a
              class="text-body text-neutral-200 no-decoration"
              routerLink="/terms-and-conditions"
            >
              Términos y Condiciones
            </a>
            <a
              class="text-body text-neutral-200 no-decoration"
              routerLink="/privacy-policy"
            >
              Aviso de Privacidad
            </a>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="footer__advice">
      <p class="text-small text-neutral-50">
        © 2024 Proquifa. Todos los derechos reservados.
      </p>
    </div>
  </div>
</footer>
